// TeamSection.jsx
import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { HiArrowNarrowRight, HiArrowNarrowLeft } from "react-icons/hi";
import logo from "../Imges/logo.png";
import Image1 from "../Imges/team-member1.png";
import Image2 from "../Imges/team-member2.png";
import Image3 from "../Imges/team-member3.png";
import "./Ourteam.css";

const TeamSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const teamMembers = [
    {
      name: "Patricia Sullivan",
      role: "Innovation Consultant",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      bgColor: "#F5F6F4",
      image: Image1,
    },
    {
      name: "Kyle Holland",
      role: "Renovation Consultant",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      bgColor: "#8F715E",
      image: Image2,
    },
    {
      name: "Patricia Sullivan",
      role: "Renovation Consultant",
      description: "Donec vehicula tincidunt nulla, a facilisis velit interdum ac.",
      bgColor: "#F5F6F4",
      image: Image3,
    },
  ];

  const checkVisibility = () => {
    if (sectionRef.current) {
      const rect = sectionRef.current.getBoundingClientRect();
      setIsVisible(rect.top < window.innerHeight && rect.bottom > 0);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", checkVisibility);
    return () => window.removeEventListener("scroll", checkVisibility);
  }, []);

  return (
    <div ref={sectionRef}>
      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        style={{ marginBottom: "50px", marginTop:'50px' }}
      >
        <span>|</span> OUR TEAM <span>|</span>
      </motion.h2>

      <div className="team-container">
        {teamMembers.map((member, index) => (
          <motion.div
            className="card"
            key={index}
            initial={{ opacity: 0, y: 50 }}
            animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
            transition={{ duration: 0.8, delay: index * 0.3 }}
          >
            <div
              className="image-container"
              style={{ backgroundColor: member.bgColor }}
            >
              <img src={member.image} alt={member.name} className="team-image" />
            </div>
            <h3>{member.name}</h3>
            <p>
              <HiArrowNarrowRight /> &nbsp;{member.role}&nbsp; <HiArrowNarrowLeft />
            </p>
            <p className="description">{member.description}</p>
            <div className="social-icons">
              <FaFacebook />
              <FaInstagram />
              <FaWhatsapp />
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default TeamSection;
